// const generateFolio = () => {
//     const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
//     const numbers = '0123456789';
//     let folio = '';

//     // Genera 2 letras aleatorias
//     for (let i = 0; i < 2; i++) {
//         folio += letters.charAt(Math.floor(Math.random() * letters.length));
//     }

//     // Genera 3 números aleatorios
//     for (let i = 0; i < 3; i++) {
//         folio += numbers.charAt(Math.floor(Math.random() * numbers.length));
//     }

//     // Genera 1 letra aleatoria más
//     folio += letters.charAt(Math.floor(Math.random() * letters.length));

//     return folio;
// };

// export const generateUniqueFolio = (pmeId, requestsList) => {
//     let folio;
//     let isUnique = false;
//     let attempts = 0;
//     const maxAttempts = 100;
  
//     while (!isUnique && attempts < maxAttempts) {
//       folio = generateFolio();
//       isUnique = !requestsList.some(
//         request => 
//           request.idPME === pmeId && 
//           request.requestDetails.folio === folio
//       );
//       attempts++;
//     }
  
//     if (!isUnique) {
//       throw new Error("No se pudo generar un folio único después de múltiples intentos.");
//     }
  
//     return folio;
// };

const generateFolio = () => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  let folio = '';

  // Genera 2 letras aleatorias
  for (let i = 0; i < 2; i++) {
      folio += letters.charAt(Math.floor(Math.random() * letters.length));
  }

  // Genera 3 números aleatorios
  for (let i = 0; i < 3; i++) {
      folio += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }

  // Genera 1 letra aleatoria más
  folio += letters.charAt(Math.floor(Math.random() * letters.length));

  return folio;
};

export const generateUniqueFolio = (pmeId, requestsList) => {
  // Validaciones iniciales
  if (!pmeId) {
      console.warn('PME ID no proporcionado para la generación del folio');
      return generateFolio(); // Generamos un folio sin verificar unicidad
  }

  if (!Array.isArray(requestsList)) {
      console.warn('Lista de solicitudes no válida');
      return generateFolio(); // Generamos un folio sin verificar unicidad
  }

  let folio;
  let isUnique = false;
  let attempts = 0;
  const maxAttempts = 100;

  while (!isUnique && attempts < maxAttempts) {
      folio = generateFolio();
      
      // Verificamos la unicidad solo contra solicitudes válidas
      isUnique = !requestsList.some(request => {
          try {
              return request?.idPME === pmeId && 
                     request?.requestDetails?.folio === folio;
          } catch (error) {
              console.warn('Error al verificar solicitud:', error);
              return false; // Si hay error, asumimos que no hay conflicto
          }
      });
      
      attempts++;
  }

  if (!isUnique) {
      console.warn("No se pudo generar un folio único después de múltiples intentos, generando folio sin verificar unicidad");
      return generateFolio(); // En lugar de lanzar error, generamos un nuevo folio
  }

  return folio;
};

// Función auxiliar para usar en el componente
export const safeFolioGeneration = (pmeId, requestsList) => {
  try {
      return generateUniqueFolio(pmeId, requestsList);
  } catch (error) {
      console.error('Error al generar folio:', error);
      return generateFolio(); // Siempre retornamos un folio, incluso si hay error
  }
};